import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import { useCountDown } from 'ahooks';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import dynamic from 'next/dynamic';
import React from 'react';
import styles from './index.module.scss';

interface Props {
    endTime: number;
}

const Countdown = dynamic(() => import('./Countdown'), {
    ssr: false, // 关键点：关闭服务端渲染
});

const EarlyBird: React.FC<Props> = ({ endTime }) => {
    const { getSystemTime, useRouter } = useGlobal();
    const router = useRouter();
    const { t } = useLang('theProduct.EarlyBird');

    const List = [
        {
            title: t('item1'),
            desc: t.rich('desc1', {
                em: (text: string) => <span className="em">{text}</span>,
            }),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1755155924882/Frame%201612707756.png',
        },
        {
            title: t('item2'),
            desc: t.rich('desc2', {
                em: (text: string) => <span className="em">{text}</span>,
            }),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1755155924625/Frame%201612707757.png',
        },
    ];

    // 倒计时
    const [, formattedRes] = useCountDown({ targetDate: endTime });

    let systemTime = getSystemTime();
    const { _timer } = router.query;
    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }
    if (systemTime >= endTime) return null;

    return (
        <>
            <div className={`${styles.comp} GtmModuleData-section`} id="EarlyBird" data-section-id={styles.comp} data-section-title={t('title')}>
                {/* <EcoTitle title={t('title')} /> */}
                <div className="countdown-container">
                    <Countdown days={formattedRes.days} hours={formattedRes.hours} minutes={formattedRes.minutes} seconds={formattedRes.seconds} />
                </div>

                {/* <div className="eco-content ">
                    <div className="cards">
                        {List.map((i, idx) => (
                            <div className="card-item" key={idx}>
                                <div className="card-item-info">
                                    <div className="card-item-title">{i.title}</div>
                                    <div className="card-item-desc">{i.desc}</div>
                                </div>
                                <img className="img" src={i.pc} alt="" />
                            </div>
                        ))}
                    </div>
                </div> */}
            </div>
        </>
    );
};
export default EarlyBird;
